/**
 * Re-read every open grid tab of one table — after the DB Manager changed its
 * rows outside the grid (TRUNCATE, 30.09.2026), so a tab does not keep showing
 * rows that no longer exist.
 *
 * Two things make a table tab show fresh rows: its cached result must be gone
 * (tabs restore from the cache on arrival instead of refetching), and
 * `filterNonce` must move (it is what re-runs the load on the tab already on
 * screen). The filter itself is kept.
 *
 * Returns how many tabs were reloaded.
 */
import { useTabsStore, setDbManagerTabs } from './tabsStore';
import { dropDbQueryResult } from './dbQueryResultCache';

export function reloadDbManagerTables({ extensionId, connId, dbName, tableName }) {
  const matches = (t) =>
    t.tableName === tableName &&
    t.connId === connId &&
    t.extensionId === extensionId &&
    (t.dbName || '') === (dbName || '');
  const ids = useTabsStore.getState().dbManagerTabs.filter(matches).map((t) => t.id);
  if (!ids.length) return 0;
  ids.forEach(dropDbQueryResult);
  setDbManagerTabs((prev) => prev.map((t) => (ids.includes(t.id) ? { ...t, filterNonce: (t.filterNonce || 0) + 1 } : t)));
  return ids.length;
}
